import { mutationAtomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type { RunAuditResponse } from './types';

export const [runAuditAtom, runAuditLoadableAtom] = mutationAtomWithLoadable<
  RunAuditResponse,
  [{ packageId?: number | null }]
>(async (_get, _set, args) => {
  const abortController = new AbortController();
  const body = args?.packageId ? { packageId: args.packageId } : {};
  const response = await request.post<RunAuditResponse, { error: string }>(
    '/admin/stale_records_audit/run',
    body,
    abortController
  );

  if (response.type === 'error') {
    throw new Error(response.data?.error ?? 'Failed to start audit');
  }

  if (response.type === 'fatal' || response.type === 'abort') {
    throw new Error(response.message);
  }

  return (response as { type: 'success'; data: RunAuditResponse }).data;
});
